var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowNarrowRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon/arrow-narrow-right"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.376 3.17567C7.48851 3.06319 7.6411 3 7.80019 3C7.95929 3 8.11188 3.06319 8.22439 3.17567L10.6244 5.57567C10.7369 5.68819 10.8001 5.84077 10.8001 5.99987C10.8001 6.15897 10.7369 6.31155 10.6244 6.42407L8.22439 8.82407C8.11123 8.93337 7.95967 8.99384 7.80235 8.99248C7.64504 8.99111 7.49455 8.92801 7.3833 8.81676C7.27206 8.70552 7.20896 8.55503 7.20759 8.39771C7.20622 8.24039 7.2667 8.08883 7.376 7.97567L8.7518 6.59987H1.8002C1.64107 6.59987 1.48845 6.53666 1.37593 6.42414C1.26341 6.31161 1.2002 6.159 1.2002 5.99987C1.2002 5.84074 1.26341 5.68813 1.37593 5.57561C1.48845 5.46309 1.64107 5.39987 1.8002 5.39987H8.7518L7.376 4.02407C7.26351 3.91156 7.20032 3.75897 7.20032 3.59987C7.20032 3.44077 7.26351 3.28819 7.376 3.17567Z",
    fill: "#616D8D"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowNarrowRight);
export default __webpack_public_path__ + "static/media/arrow-narrow-right.157baf11e533300360e472b263ee20f1.svg";
export { ForwardRef as ReactComponent };